import React from "react";
import { Helmet } from "react-helmet";
import "../styles/faq.css";
import HomeFooter from "../components/Home/HomeFooter";
import MainHeader from "../components/Main/MainHeader";

export default function FAQ() {
  return (
    <>
    <MainHeader />
    <div className="faqpolicy">
      {/* Meta Info */}
      <Helmet>
        <title>FAQ | Anyworq – A to Z Services in Bangalore</title>
        <meta
          name="description"
          content="Find answers to frequently asked questions about Anyworq services, dealers, payments, privacy, and policies. Trusted A to Z services in Bangalore."
        />
        <link rel="canonical" href="https://www.anyworq.com/faq" />
        <meta
  name="keywords"
  content="Anyworq FAQ, Bangalore services, A to Z services, verified dealers, home services, business services, personal services, Anyworq support"
/>
        {/* FAQ Schema */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What is Anyworq?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Anyworq is Bangalore’s trusted A to Z services platform, connecting customers with verified dealers for home, business, personal, and specialized services."
                }
              },
              {
                "@type": "Question",
                "name": "Which city does Anyworq serve?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Currently, Anyworq provides services exclusively in Bangalore."
                }
              },
              {
                "@type": "Question",
                "name": "What kind of services can I find on Anyworq?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Anyworq covers all services including home, business, personal, and specialized services under one roof."
                }
              },
              {
                "@type": "Question",
                "name": "How do I raise a service enquiry?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Browse our service categories, select your service, and submit your enquiry. It will be assigned to a relevant verified dealer in Bangalore."
                }
              }
            ]
          }
          `}
        </script>
      </Helmet>

      {/* Header */}
      <div className="faqpolicy-header">
        <h1>FAQ – Anyworq</h1>
        <p>Welcome to the Anyworq Frequently Asked Questions page.</p>
      </div>

      {/* General Questions */}
      <div className="faq-section">
        <h2>General Questions</h2>
        <div className="faq-item">
          <p className="question"> What is Anyworq?</p>
          <p>
            Anyworq is Bangalore’s trusted A to Z services platform, connecting
            customers with verified dealers for home, business, personal, and
            specialized services.
          </p>
        </div>
        <div className="faq-item">
          <p className="question"> Which city does Anyworq serve?</p>
          <p>Currently, Anyworq provides services exclusively in Bangalore.</p>
        </div>
        <div className="faq-item">
          <p className="question"> What kind of services can I find on Anyworq?</p>
          <p>We cover all services under one roof, including:</p>
          <ul>
            <li>Home Services: plumbing, electrical, carpentry, painting, cleaning, pest control, appliance repair.</li>
            <li>Business Services: IT solutions, digital marketing, accounting, HR support, logistics, consulting.</li>
            <li>Personal Services: event planning, beauty, fitness, coaching, healthcare.</li>
            <li>Specialized Services: real estate support, interior design, travel bookings, automobile care, and more.</li>
          </ul>
        </div>
        <div className="faq-item">
          <p className="question"> How do I raise a service enquiry?</p>
          <p>
            Browse our service categories, select your service, and submit your
            enquiry. Our system will assign it to a relevant verified dealer in
            Bangalore.
          </p>
        </div>
      </div>

      {/* Dealer & Enquiry */}
      <div className="faq-section">
        <h2>Dealer & Enquiry Related</h2>
        <div className="faq-item">
          <p className="question"> Who are the dealers listed on Anyworq?</p>
          <p>
            Our dealers are verified service providers in Bangalore with expertise
            in specific service categories.
          </p>
        </div>
        <div className="faq-item">
          <p className="question"> How is my enquiry assigned?</p>
          <p>
            Once you submit an enquiry, our system automatically matches it with
            the most suitable dealer profile based on your requirements.
          </p>
        </div>
        <div className="faq-item">
          <p className="question"> Can I contact a dealer directly?</p>
          <p>
            Yes. After assignment, you will receive the dealer’s contact details
            and can coordinate directly with them.
          </p>
        </div>
        <div className="faq-item">
          <p className="question"> How do I know if a dealer is trustworthy?</p>
          <p>
            All dealers go through a strict verification process. Customer reviews
            are also encouraged to maintain transparency and trust.
          </p>
        </div>
      </div>

      {/* Payments */}
      <div className="faq-section">
        <h2>Payments & Pricing</h2>
        <div className="faq-item">
          <p className="question"> How are payments handled?</p>
          <p>
            Payments can be made directly to dealers or through the Anyworq
            platform (if available). Confirm payment methods before services begin
            for safety.
          </p>
        </div>
        <div className="faq-item">
          <p className="question"> Are there hidden charges?</p>
          <p>
            No. Dealers must provide clear and transparent pricing, and Anyworq
            promotes fair service charges.
          </p>
        </div>
        <div className="faq-item">
          <p className="question"> What if I am not satisfied with the service?</p>
          <p>
            We recommend first resolving issues directly with the dealer. If the
            issue persists, you may report it to Anyworq for review and guidance.
          </p>
        </div>
      </div>

      {/* Privacy */}
      <div className="faq-section">
        <h2>Privacy & Security</h2>
        <div className="faq-item">
          <p className="question"> How does Anyworq protect my personal data?</p>
          <p>
            We take privacy seriously. Your information is shared only with the
            assigned dealer to complete your enquiry. Anyworq does not sell or
            misuse your data.
          </p>
        </div>
        <div className="faq-item">
          <p className="question"> Can I delete my account or personal data?</p>
          <p>Yes. Contact us to request account deletion or data removal.</p>
        </div>
        <div className="faq-item">
          <p className="question"> Do you use cookies?</p>
          <p>
            Yes. Cookies are used to enhance user experience and improve platform
            performance.
          </p>
        </div>
      </div>

      {/* Policies */}
      <div className="faq-section">
        <h2>Policies</h2>
        <div className="faq-item">
          <p className="question"> Where can I read the Privacy Policy?</p>
          <p>View our Privacy Policy</p>
        </div>
        <div className="faq-item">
          <p className="question"> Where can I read the Terms of Service?</p>
          <p>View our Terms of Service</p>
        </div>
        <div className="faq-item">
          <p className="question"> Where can I read the Terms & Conditions?</p>
          <p>View our Terms & Conditions</p>
        </div>
      </div>

      {/* Contact */}
      <div className="faq-section">
        <h2>Contact Us</h2>
        <p>Still have questions? Reach out to us:</p>
        <p>📧 Email: support@anyworq.com</p>
      </div>
    </div>
    <HomeFooter />
    </>
  );
}
